<main>
  <loading-overlay [isLoading]="isLoading > 0" />

  <header>
    <div class="headline">
      <h1>{{ requisition ? requisition.number : ('Requisitions.new_requisition' | translateWF: 'New Requisition') }}</h1>
    </div>
    <div class="buttons">
      <p-button severity="secondary" icon="pi pi-print" *ngIf="requisition?.id" (click)="downloadRequisitionPdf()" pTooltip="Download PDF" size="large"></p-button>
      <!-- Approved all button -->
      <ng-container *ngIf="allowApprove">
        <p-button severity="danger" [label]="'Requisitions.reject' | translateWF: 'Reject'" *ngIf="!checked && !containsStatusRequistion(['Rejected'])" (onClick)="onReject()" />
        <p-button
          *ngIf="!checked && ((isLastApprover() && allEntriesApprovedOrPending()) || !isLastApprover())"
          (onClick)="onclickApproveAll()"
          severity="secondary"
          [label]="'Requisitions.approve_all' | translateWF: 'Approve All'"
        />
      </ng-container>
      <div class="form-box-row" *ngIf="allowApprove && checked">
        <label for="">Hard Approve</label>
        <p-toggleswitch [(ngModel)]="hardApprove" />
      </div>
      <p-button
        [label]="'Requisitions.save' | translateWF: 'Save'"
        (click)="saveRequisition()"
        *ngIf="!requisition || !showReadonlyStatus() || (allowApprove && checked) || isDraftStatus() || isAwaitingCreatorChangesAndIsCreator() || canSaveParentRequisition()"
      />
      <p-button [label]="'Requisitions.cancel' | translateWF: 'Cancel'" variant="outlined" (click)="cancel()" />
    </div>
  </header>

  <div class="content">
    <p-panel [header]="'Requisition_Details_General_Information' | translateWF: 'General Information'">
      <p-card>
        <div class="col">
          <div class="grid-12 gap-[1rem]">
            <div class="span-6">
              <div class="form-box">
                <label for="">{{ 'Requisitions.status' | translateWF: 'Status' }}</label>
                @if (showReadonlyStatus()) {
                  <input pInputText type="text" class="p-inputtext p-component w-full disabled-ui" [value]="getStatusDisplayName(requisition?.statusReference || '')" disabled />
                } @else {
                  <p-select [formControl]="statusReferenceControl" [options]="filterRequisitionStatus()" optionLabel="fieldToDisplay" optionValue="id" class="w-full" />
                }
              </div>
            </div>
            <div class="span-6 row-start-center">
              <div class="form-box w-full h-[50px]" *ngIf="allowApprove">
                <p-toggleswitch [(ngModel)]="checked" (onChange)="onMakeChangeRequisition($event)"></p-toggleswitch>
                <label class="ml-2">{{
                  'Requisitions.approve_or_changes'
                    | translateWF
                      : 'Approve or make partial
                  changes'
                }}</label>
              </div>
              <div class="w-full h-[50px] flex items-end">
                <div class="flex-grow"></div>
                <label>{{ requisition?.approvers?.length ?? 0 }}/{{ requisition?.requiredApprovers ?? 0 }} Approvers</label>
              </div>
            </div>
          </div>

          <form [formGroup]="requisitionForm">
            <div class="grid-2 gap-[1rem]">
              <div class="form-box">
                <label for="">{{ 'Requisitions.requisition_created_date' | translateWF: 'Created Date' }}</label>
                <p-datepicker fluid class="w-full disabled-ui" formControlName="createdDate" [iconDisplay]="'input'" [showIcon]="true" />
              </div>
              <div class="form-box">
                <label for="">{{ 'Requisitions.requesting_user' | translateWF: 'Requesting' }}</label>
                <input pInputText type="text" class="p-inputtext p-component w-full" formControlName="createdBy" />
              </div>
              <div class="form-box" *ngIf="hasParentRequisition()">
                <label for="">{{ 'Requisitions.assigned_user' | translateWF: 'Assigned user' }}</label>
                <p-autocomplete
                  fluid
                  class="w-full"
                  formControlName="assignedUser"
                  [forceSelection]="true"
                  [dropdown]="true"
                  [suggestions]="usersToDisplay"
                  optionLabel="fieldToDisplay"
                  (completeMethod)="searchUser($event)"
                />
              </div>
              <div class="form-box">
                <label for="">{{ 'Requisitions.department' | translateWF: 'Department' }}</label>
                <p-autocomplete
                  fluid
                  class="w-full"
                  formControlName="departmentReference"
                  [forceSelection]="true"
                  [dropdown]="true"
                  [suggestions]="departmentsToDisplay"
                  optionLabel="fieldToDisplay"
                  (completeMethod)="searchDepartment($event)"
                  [ngClass]="{ 'ng-invalid ng-dirty': hasFieldError('departmentReference') }"
                />
                <small class="p-error" *ngIf="hasFieldError('departmentReference')">
                  {{ 'Requisitions.department_required' | translateWF: 'Department is required' }}
                </small>
              </div>
              <div class="form-box">
                <label for="">{{ 'Requisitions.requisition_type' | translateWF: 'Requisition Type' }}</label>
                <p-select
                  formControlName="requisitionType"
                  [options]="setOptionsForPrimeNg(requisitionTypes)"
                  optionLabel="label"
                  optionValue="value"
                  class="w-full"
                  [ngClass]="{ 'ng-invalid ng-dirty': hasFieldError('requisitionType') }"
                />
                <small class="p-error" *ngIf="hasFieldError('requisitionType')">
                  {{ 'Requisitions.requisition_type_required' | translateWF: 'Requisition Type is required' }}
                </small>
              </div>
              <div class="form-box">
                <label for="">{{ 'Requisitions.requisition_priority' | translateWF: 'Requisition Priority' }}</label>
                <p-select
                  formControlName="priority"
                  [options]="setOptionsForPrimeNg(requisitionPriority)"
                  optionLabel="label"
                  optionValue="value"
                  class="w-full"
                  [ngClass]="{ 'ng-invalid ng-dirty': hasFieldError('priority') }"
                />
                <small class="p-error" *ngIf="hasFieldError('priority')">
                  {{ 'Requisitions.priority_required' | translateWF: 'Priority is required' }}
                </small>
              </div>
              <div class="form-box" *ngIf="requisition?.requisitionProcurementCategory">
                <label for="">{{ 'Requisitions.procurement_category' | translateWF: 'Procurement Category' }}</label>
                <input pInputText type="text" class="p-inputtext p-component w-full disabled-ui" [value]="requisition?.requisitionProcurementCategory?.name | localized" disabled />
              </div>
              <div class="form-box">
                <label for="">{{ 'Requisitions.destination_warehouse' | translateWF: 'Destination Warehouse' }}</label>
                @if (requisition?.destinationLocationCode) {
                  <!-- Readonly mode: inherited from Supply Request -->
                  <input pInputText type="text" class="p-inputtext p-component w-full disabled-ui" [value]="requisition?.destinationLocationName | localized" disabled />
                } @else {
                  <!-- Editable mode: user can select destination -->
                  <p-select
                    formControlName="destinationLocationCode"
                    [options]="destinationWarehouseOptions"
                    optionLabel="label"
                    optionValue="code"
                    class="w-full"
                    [ngClass]="{ 'ng-invalid ng-dirty': hasFieldError('destinationLocationCode') }"
                    placeholder="Select destination warehouse"
                  />
                  <small class="p-error" *ngIf="hasFieldError('destinationLocationCode')">
                    {{ 'Requisitions.destination_warehouse_required' | translateWF: 'Destination warehouse is required' }}
                  </small>
                }
              </div>
            </div>
          </form>

          <div class="history-wrapper">
            @for (approver of requisition?.approvers ?? []; track $index) {
              <p>
                <i class="pi pi-check" style="font-size: 12px; color: #0eb855"></i> Approved by <strong>{{ approver.username }}</strong> •
                <span>{{ approver.approvedAt | date: 'shortDate' }}</span>
              </p>
            }
          </div>
        </div>
      </p-card>
    </p-panel>

    <!-- Related Purchase Orders Section -->
    @if (relatedPurchaseOrderItems.length > 0) {
      <p-panel [header]="'Requisitions.related_purchase_orders' | translateWF: 'Related Purchase Orders'">
        <p-card data-variant="compact">
          <p-table
            [value]="relatedPurchaseOrderItems"
            [paginator]="relatedPurchaseOrderItems.length > 10"
            [rows]="10"
            [rowsPerPageOptions]="[10, 20, 50]"
            [showCurrentPageReport]="true"
          >
            <ng-template pTemplate="header">
              <tr>
                <th>{{ 'Requisitions.po_number' | translateWF: 'Purchase Order Number' }}</th>
                <th>{{ 'Requisitions.status' | translateWF: 'Status' }}</th>
                <th>{{ 'ItemMaster_TableItemCode' | translateWF: 'Item Code' }}</th>
                <th>{{ 'ItemMaster_TableName' | translateWF: 'Item Name' }}</th>
                <th>{{ 'Requisitions.quantity' | translateWF: 'Quantity' }}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item>
              <tr>
                <td>
                  <a [routerLink]="['/purchase-order-details']" [queryParams]="{ id: item.purchaseOrderReference }" target="_blank" class="text-primary hover:underline">
                    {{ item.purchaseOrderNumber }}
                  </a>
                </td>
                <td>{{ getPurchaseOrderStatusLabel(item.status) }}</td>
                <td>{{ item.itemCode }}</td>
                <td>{{ item.itemDisplayName | localized }}</td>
                <td>{{ item.quantity }}</td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="5" class="text-center">
                  <p-message severity="secondary">
                    {{ 'Requisitions.no_related_purchase_orders' | translateWF: 'No related purchase orders found' }}
                  </p-message>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </p-card>
      </p-panel>
    }

    @if (!isStatusInQuotationRange()) {
      <p-panel [header]="'Requisition_Items_Table' | translateWF: 'Items To Requisition'">
        <p-card data-variant="compact">
          <p-table
            #itemsToRequisitionTable
            id="ItemsToRequisition"
            [value]="itemsToRequisitionForTable"
            [paginator]="true"
            [rows]="20"
            [rowsPerPageOptions]="[20, 30, 50, 100]"
            paginatorDropdownAppendTo="body"
            [showCurrentPageReport]="true"
          >
            <ng-template pTemplate="header">
              <tr>
                <th>{{ 'ItemMaster_TableItemCode' | translateWF: 'Item Code' }}</th>
                <th>{{ 'ItemMaster_TableItemDescription' | translateWF: 'Item Description' }}</th>
                <th>{{ 'Requisitions.quantity' | translateWF: 'Quantity' }}</th>
                <th>{{ 'Requisitions.comment' | translateWF: 'Comment' }}</th>
                <!-- Show approved column if allowApprove OR if status is in range 2-4 -->
                <th *ngIf="allowApprove || isStatusInApprovalRange()">{{ 'Requisitions.approved' | translateWF: 'Approved' }}</th>
                <th *ngIf="visibleDeleteButton">{{ 'Actions' | translateWF: 'Actions' }}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-entryForm let-index="rowIndex">
              <tr>
                <td>{{ entryForm.get('itemCode')?.value }}</td>

                <td>{{ getItemDescription(entryForm.get('itemCode')?.value) }}</td>

                <td>
                  <p-inputGroup>
                    <input
                      pInputText
                      type="number"
                      class="p-inputtext p-component w-full"
                      min="1"
                      [formControl]="entryForm.get('quantity')"
                      [ngClass]="{ 'ng-invalid ng-dirty': requisitionFormSubmitted && entryForm.get('quantity')?.invalid }"
                    />
                    <p-inputgroup-addon>
                      <span>{{ uoms[entryForm.get('uom')?.value] }}</span>
                    </p-inputgroup-addon>
                  </p-inputGroup>
                </td>

                <td>
                  @if (readonlyMode || !visibleDeleteButton) {
                    {{ entryForm.get('comment')?.value }}
                  } @else {
                    <input pInputText type="text" class="p-inputtext p-component w-full" [formControl]="entryForm.get('comment')" />
                  }
                </td>

                <td *ngIf="allowApprove || isStatusInApprovalRange()">
                  <!-- Show checkbox if user can approve, otherwise show read-only status -->
                  <p-checkbox *ngIf="allowApprove" [binary]="true" [formControl]="entryForm.get('approved')" />
                  <span *ngIf="!allowApprove && isStatusInApprovalRange()">
                    <i class="pi" [ngClass]="entryForm.get('approved')?.value ? 'pi-check text-green-500' : 'pi-times text-red-500'"> </i>
                    {{ entryForm.get('approved')?.value ? 'Approved' : 'Not Approved' }}
                  </span>
                </td>
                <td *ngIf="visibleDeleteButton">
                  <p-button icon="pi pi-trash" severity="danger" variant="outlined" (click)="removeItemFromRequisition(index)" />
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="12" class="text-center">
                  <p-message severity="secondary">
                    {{ 'Requisitions.no_entries_added' | translateWF: 'No entries have been added to this requisition' }}
                  </p-message>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </p-card>
      </p-panel>
    } @else {
      <app-quotations-viewer [requisition]="requisition" *ngIf="requisition" (emitRefreshPage)="reloadPage()" />
    }

    <p-panel [header]="'Requisitions.items' | translateWF: 'Items'" *ngIf="!readonlyMode && (isDraftStatus() || requisition == null || isAwaitingCreatorChangesAndIsCreator())">
      <ng-template pTemplate="icons">
        <form [formGroup]="filterForm">
          <div class="input-wrapper">
            <p-autoComplete
              [dropdown]="true"
              class="w-full"
              dropdownIcon="pi pi-search"
              [suggestions]="allItems"
              field="fieldToDisplay"
              (completeMethod)="applyFilters()"
              formControlName="description"
              placeholder="{{ 'Requisitions.search_items' | translateWF: 'Search items...' }}"
            />
          </div>
        </form>
      </ng-template>
      <p-card data-variant="compact">
        <p-table
          id="ItemsToSearch"
          dataKey="id"
          [value]="allItems"
          [paginator]="true"
          [rows]="20"
          [rowsPerPageOptions]="[20, 30, 50, 100]"
          paginatorDropdownAppendTo="body"
          selectionMode="single"
        >
          <ng-template pTemplate="header">
            <tr>
              <th>{{ 'ItemMaster_TableItemCode' | translateWF: 'Item Code' }}</th>
              <th>{{ 'ItemMaster_TableName' | translateWF: 'Name' }}</th>
              <th>{{ 'ItemMaster_TableDescription' | translateWF: 'Description' }}</th>
              <th *ngIf="visibleDeleteButton">{{ 'Actions' | translateWF: 'Actions' }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item>
            <tr>
              <td style="max-width: 200px">{{ item.itemCode }}</td>
              <td style="min-width: 350px">{{ item.itemDisplayName | localized }}</td>
              <td style="min-width: 350px">{{ item.itemDescription | localized }}</td>
              <td *ngIf="visibleDeleteButton">
                <p-button icon="pi pi-plus" variant="outlined" (click)="addItemToRequisition(item)" [disabled]="isDisabledAddButton(item)" />
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="12" class="text-center">
                <p-message severity="info">
                  {{ 'Requisitions.no_items_found' | translateWF: 'No items found. Try adjusting your search criteria' }}
                </p-message>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-card>
    </p-panel>
  </div>
</main>
<p-toast position="bottom-right" key="br"></p-toast>

<!-- Main Confirmation Dialog -->
<!-- <p-confirmDialog key="main"></p-confirmDialog> -->

<!-- Custom Save Confirmation Dialog -->
<p-confirmDialog key="save-dialog" #cd>
  <ng-template #headless let-message let-onAccept="onAccept" let-onReject="onReject">
    <div class="col-start-center p-8 bg-white dark:bg-gray-900 rounded-xl w-full max-w-md mx-auto shadow-xl">
      <div class="rounded-full bg-blue-600 text-white inline-flex justify-center items-center h-24 w-24 -mt-20 shadow-lg">
        <i [class]="message.icon || 'pi pi-question-circle'" class="text-5xl"></i>
      </div>

      <span class="font-bold text-2xl text-center mt-6 mb-2">
        {{ message.header }}
      </span>

      <div class="text-center text-lg leading-relaxed mb-4" [innerHTML]="message.message"></div>

      <!-- Hard Approve Checkbox Section -->
      <div class="w-full mb-4" *ngIf="allowApprove">
        <div class="row-start-center p-3 bg-yellow-50 dark:bg-yellow-900/20 rounded-lg border border-yellow-200 dark:border-yellow-700">
          <p-checkbox [(ngModel)]="hardApprove" binary="true" inputId="hardApproveCheck" class="mr-3"> </p-checkbox>
          <label for="hardApproveCheck" class="text-sm font-medium text-yellow-800 dark:text-yellow-200 cursor-pointer">
            <i class="pi pi-exclamation-triangle text-yellow-600 mr-1"></i>
            Enable Hard Approve Mode
          </label>
        </div>
        <small class="text-xs text-gray-600 dark:text-gray-400 mt-1 block"> Hard approve will bypass normal approval workflows and automatically approve selected entries </small>
      </div>

      <div class="row-center-stretch gap-4 mt-6 w-full">
        <p-button [label]="message.rejectLabel || ('cancel' | translateWF: 'Cancel')" (click)="onReject()" variant="outlined" />
        <p-button
          [label]="message.acceptLabel || ('save' | translateWF: 'Save')"
          (click)="onAccept()"
          [severity]="hardApprove ? 'danger' : 'primary'"
          [icon]="hardApprove ? 'pi pi-lock' : 'pi pi-save'"
        />
      </div>
    </div>
  </ng-template>
</p-confirmDialog>
